<ft-user-profile [user]="user" class="pointer"></ft-user-profile>
<ion-label style="white-space: normal;">
  <div>
    <h3> {{user.uName}} </h3>
    <h4 style="font-size: 11px;"> {{user['subText']}} </h4>
  </div>
</ion-label>
